import { Component } from '@angular/core';

import { pedidoConfirmandoERP } from '../../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge-confirmando-erp',
    templateUrl: './pedido-status-badge-confirmando-erp.component.html',
    styleUrls: ['./pedido-status-badge-confirmando-erp.component.less']
})
export class PedidoStatusBadgeConfirmandoERPComponent {
    status = pedidoConfirmandoERP;
}
